<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    content-class="sc-modal sc-modal--sm"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn small color="primary" class="yt-cred-add-btn" v-bind="attrs" v-on="on">
        <v-icon small class="mr-1">mdi-plus</v-icon>
        Cadastrar credenciais
      </v-btn>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">mdi-key-plus</v-icon>
        <div>
          <span class="sc-modal__title">Cadastrar credenciais</span>
          <span class="sc-modal__subtitle">Configure as credenciais da API do YouTube</span>
        </div>
      </div>

      <div class="sc-modal__body">
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Client ID</label>
          <v-text-field
            solo
            flat
            dense
            hide-details="auto"
            v-model="client_id"
            background-color="surface_tertiary"
            placeholder="Cole o Client ID aqui"
          />
        </div>
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Client Secret</label>
          <v-text-field
            solo
            flat
            dense
            hide-details="auto"
            v-model="client_secret"
            background-color="surface_tertiary"
            placeholder="Cole o Client Secret aqui"
          />
        </div>
      </div>

      <div class="sc-modal__footer">
        <v-btn text @click="dialog = false" class="modal-btn-cancel">Cancelar</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          @click.prevent="cadastrarCredenciais"
          class="modal-btn-confirm"
        >
          <v-icon small class="mr-1">mdi-check</v-icon>
          Salvar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions } from "vuex";

export default {
  name: "ModalCadastrarCredenciaisYoutube",
  data() {
    return {
      dialog: false,
      client_id: null,
      client_secret: null,
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      getProducaoCredenciaisYoutube: "producoes/getProducaoCredenciaisYoutube",
    }),
    async cadastrarCredenciais() {
      if (!this.client_id || !this.client_secret) {
        this.$toast.warning("Insira os dados corretamente.");
        return;
      }
      this.loading = true;
      try {
        await apiClient.post("youtube/create", {
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          client_id: this.client_id,
          client_secret: this.client_secret,
        });
        this.$toast.success("Credenciais salvas com sucesso.");
        this.dialog = false;
        await this.getProducaoCredenciaisYoutube(
          this.$store.state.producoes.selectedProducao.cod_producao
        );
      } catch (error) {
        this.$toast.error("Erro ao cadastrar credenciais.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.yt-cred-add-btn {
  text-transform: none;
  font-weight: var(--sc-weight-semi);
  letter-spacing: 0;
  border-radius: var(--sc-radius-md);
}
</style>
